import { isResourceDetailImage } from './resourceDetailGuards.js';

const getSimilarTo = (target) => {
  if (typeof target === "string") {
    return {
      mode: "hybrid",
      text: target
    };
  }
  const isImage = isResourceDetailImage(target);
  if (isImage) {
    return {
      mode: "similar-image",
      itemId: target.id
    };
  }
  return {
    mode: "similar-text",
    itemId: target.id
  };
};

export { getSimilarTo };
//# sourceMappingURL=getSimilarTo.js.map
